export const SET_BUTTON_LOADER = 'SET_BUTTON_LOADER'

export const setButtonLoader = (payload) => {
    return {
        type: SET_BUTTON_LOADER,
        payload
    }
}